import { combineReducers } from 'redux';
import ConfigReducer from './configReducer';
import ShippingReducer from './shippingReducer';
import GuideReducer from './guideReducer';

export default combineReducers({
    ConfigReducer,
    ShippingReducer,
    GuideReducer
})